'use client';

import { CommonImage } from '@/components/common';
import dynamic from 'next/dynamic';

const ReactPlayer = dynamic(() => import('react-player'), { ssr: false });

interface TProps {
  eventVideoLink: string;
  posters: Array<{ url: string; name?: string }>;
}

const EventCarousel = ({ posters, eventVideoLink }: TProps) => {
  return (
    <div className='w-full'>
      {eventVideoLink ? (
        <div className='h-56 w-full rounded-2xl sm:h-72 md:h-80 lg:h-105 [&_iframe]:rounded-2xl'>
          <ReactPlayer
            src={eventVideoLink}
            className='w-full rounded-2xl lg:h-105'
            style={{
              width: '100%',
              height: '100%',
              borderRadius: '1rem',
            }}
          />
        </div>
      ) : (
        <div className='h-56 w-full rounded-2xl sm:h-72 md:h-80 lg:h-100 [&_iframe]:rounded-2xl'>
          <CommonImage
            src={posters[0]?.url}
            alt={posters[0]?.name || 'Greet'}
            width={500}
            height={300}
            className='h-56 w-full rounded-2xl sm:h-72 md:h-80 lg:h-100'
            priority
          />
        </div>
      )}
    </div>
  );
};

export default EventCarousel;
